import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useOperation } from "../../Context/OperationContext";
import style from "../../assets/jss/disal-main/Layouts/Operation";
import Grid from "@material-ui/core/Grid";
import calendarIcon from "../../assets/img/calendario icon.svg";
import masIcon from "../../assets/img/add.svg";
import pendingIcon from "../../assets/img/pendientes icon.svg";
import checkIcon from "../../assets/img/check icon.svg";
import { getCurrentDate } from "../../Component/date";
import MiningSiteSelector from "./MiningSiteSelector";
import ContentGlobal from "../../Component/Content/ContentGlobal";

const useStyles = makeStyles(style);
const GlobalOperation = () => {
  const classes = useStyles();

  const {
    globalData, 
    fetchGlobalData 
  } = useOperation();

  useEffect(() => {
    fetchGlobalData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { date, monthNumber, year } = getCurrentDate();

  return (
    <Grid container className={classes.operation}>
      <Grid item md={12}>
        <div className={classes.boxTitle}>
          <h4>Monitoreo total de puntos generadores</h4>
          <p>
            <span>{date}</span>
            <span className={classes.slash}>/</span>
            <span>{monthNumber}</span>
            <span className={classes.slash}>/</span>
            <span>{year}</span>
          </p>
        </div>
      </Grid>
      <Grid item md={12}>
        <Grid container>
          <Grid
            item
            xs={12}
            sm={3}
            className={classes.paddingRight}
          >
            <div className={classes.boxMonitoring + " bcgBlue"}>
              <div className="img-icons">
                <img src={calendarIcon} alt="Calendar Icon" />
              </div>
              <div className="info-monitoring">
                <p className="main-word">Programados</p>
                <p className="total-count">
                  <span>{globalData.total}</span>hoy
                </p>
              </div>
            </div>
          </Grid>
          <Grid
            item
            xs={12}
            sm={3}
            className={
              classes.paddingRight +
              " " +
              classes.paddingLeft
            }
          >
            <div className={classes.boxMonitoring + " bcgYellow"}>
              <div className="img-icons">
                <img src={pendingIcon} alt="Pendiente Icon" />
              </div>
              <div className="info-monitoring">
                <p className="main-word">Pendientes</p>
                <p className="total-count">
                  <span>{globalData.pending}</span>hoy
                </p>
              </div>
            </div>
          </Grid>
          <Grid
            item
            xs={12}
            sm={3}
            className={
              classes.paddingRight +
              " " +
              classes.paddingLeft
            }
          >
            <div className={classes.boxMonitoring + " bcgGreen"}>
              <div className="img-icons">
                <img src={checkIcon} alt="Check Icon" />
              </div>
              <div className="info-monitoring">
                <p className="main-word">Finalizados</p>
                <p className="total-count">
                  <span>{globalData.finished}</span>hoy
                </p>
              </div>
            </div>
          </Grid>
          <Grid
            item
            xs={12}
            sm={3}
            className={classes.paddingLeft}
          >
            <div className={classes.boxMonitoring + " bcgRed"}>
              <div className="img-icons">
                <img src={masIcon} alt="Check Icon" />
              </div>
              <div className="info-monitoring">
                <p className="main-word">No programados</p>
                <p className="total-count">
                  <span>{globalData.noProgramated}</span>hoy
                </p>
              </div>
            </div>
          </Grid>
        </Grid>
      </Grid>
      <MiningSiteSelector />
      <Grid item xs={12} sm={12} className={classes.tableStyle}>
        <div className={classes.contentTitle}>
          <p className={classes.titleTable}>Mostrando resultados de todas las plantas</p>
        </div>
        <ContentGlobal items={globalData.data} />
      </Grid>
    </Grid>
  )
}

export default GlobalOperation;
